import { render, staticRenderFns } from "./BaseInputSearch.vue?vue&type=template&id=a2f74894&"
import script from "./BaseInputSearch.vue?vue&type=script&lang=ts&"
export * from "./BaseInputSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports